/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckEligibilityDetails
 */
export interface CheckEligibilityDetails {
    /**
     * Name of the bed involved in the conflict or action
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    bed_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    previous_bed_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    previous_bed_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    current_bed_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    bed_change_date?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    swap_date?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    swapped_with_lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    swapped_with_lead_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    other_resident_current_bed_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckEligibilityDetails
     */
    other_resident_original_bed_name?: string;
}

/**
 * Check if a given object implements the CheckEligibilityDetails interface.
 */
export function instanceOfCheckEligibilityDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckEligibilityDetailsFromJSON(json: any): CheckEligibilityDetails {
    return CheckEligibilityDetailsFromJSONTyped(json, false);
}

export function CheckEligibilityDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEligibilityDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bed_name': !exists(json, 'bed_name') ? undefined : json['bed_name'],
        'previous_bed_name': !exists(json, 'previous_bed_name') ? undefined : json['previous_bed_name'],
        'previous_bed_id': !exists(json, 'previous_bed_id') ? undefined : json['previous_bed_id'],
        'current_bed_name': !exists(json, 'current_bed_name') ? undefined : json['current_bed_name'],
        'bed_change_date': !exists(json, 'bed_change_date') ? undefined : json['bed_change_date'],
        'swap_date': !exists(json, 'swap_date') ? undefined : json['swap_date'],
        'swapped_with_lead_id': !exists(json, 'swapped_with_lead_id') ? undefined : json['swapped_with_lead_id'],
        'swapped_with_lead_name': !exists(json, 'swapped_with_lead_name') ? undefined : json['swapped_with_lead_name'],
        'other_resident_current_bed_name': !exists(json, 'other_resident_current_bed_name') ? undefined : json['other_resident_current_bed_name'],
        'other_resident_original_bed_name': !exists(json, 'other_resident_original_bed_name') ? undefined : json['other_resident_original_bed_name'],
    };
}

export function CheckEligibilityDetailsToJSON(value?: CheckEligibilityDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bed_name': value.bed_name,
        'previous_bed_name': value.previous_bed_name,
        'previous_bed_id': value.previous_bed_id,
        'current_bed_name': value.current_bed_name,
        'bed_change_date': value.bed_change_date,
        'swap_date': value.swap_date,
        'swapped_with_lead_id': value.swapped_with_lead_id,
        'swapped_with_lead_name': value.swapped_with_lead_name,
        'other_resident_current_bed_name': value.other_resident_current_bed_name,
        'other_resident_original_bed_name': value.other_resident_original_bed_name,
    };
}

